module.exports = __webpack_public_path__ + "static/media/button-schmuck.69ada9d1.svg";